import { render, staticRenderFns } from "./RouterTable.vue?vue&type=template&id=0f5465d3&"
import script from "./RouterTable.vue?vue&type=script&lang=js&"
export * from "./RouterTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports